exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.post-image-node-container[data-v-1f9be6e0] {\n  width: calc(100% + 4rem);\n}\n.post-image-node-wrapper[data-v-1f9be6e0] {\n  width: fit-content;\n}\n.clamp-title[data-v-1f9be6e0] {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n@media screen and (max-width: 1024px) {\n.post-image-node-container[data-v-1f9be6e0] {\n    height: 20rem;\n}\n}\n", ""]);

// exports
